<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <!-- <h3 class="text-primary mb-4 mr-3 font-30px">
      {{ $t("general_informations_operation") }}
    </h3> -->

    <div class="giga-fields">
      <div
        :class="[
          ficheValidator.provisionalBeginDate.$anyDirty &&
          ficheValidator.provisionalBeginDate.$invalid
            ? 'field-hasError'
            : '',
          !ficheValidator.provisionalBeginDate.required
            ? 'field-isRequired'
            : ''
        ]"
        class="giga-input_field col-lg-6"
      >
        <label class="input-field_label"
          >{{ $t("provisional_commitment_date_for_the_operation") }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-field_area">
          <date-picker
            id="provisional_commitment_date_for_the_operation"
            v-model="ficheValidator.provisionalBeginDate.$model"
            format="dddd D MMMM YYYY"
            valueType="YYYY-MM-DD"
            prefix-class="xmx"
            :placeholder="$t('provisional_commitment_date_for_the_operation')"
            :clearable="false"
            :editable="false"
            class="big-input"
            :disabled="simulationStatus === 'TO_BE_TRANSFORMED' || isVIEWER"
            :disabled-date="notAfterProvisionalCompletionDate"
            @change="$emit('setPeriod', ficheValidator)"
          >
            <template slot="icon-calendar">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 3H4C2.34315 3 1 4.34315 1 6V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V6C23 4.34315 21.6569 3 20 3Z"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 9H23"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 5V1"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6 5V1"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18 5V1"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 14H7"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11 14H13"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 14H19"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 18H7"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11 18H13"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 18H19"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </date-picker>
          <div
            v-if="
              ficheValidator.provisionalBeginDate.$anyDirty &&
                ficheValidator.provisionalBeginDate.$invalid
            "
            class="validation-field-holder"
          >
            <small v-if="!ficheValidator.provisionalBeginDate.required">
              {{ $t("required_field") }}
            </small>
          </div>
        </div>
      </div>

      <div class="giga-input_field col-lg-6">
        <label class="input-field_label"
          >{{ $t("provisional_completion_date_for_the_operation") }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-field_area">
          <date-picker
            id="provisional_completion_date_for_the_operation"
            v-model="ficheValidator.provisionalCompletionDate.$model"
            format="dddd D MMMM YYYY"
            valueType="YYYY-MM-DD"
            prefix-class="xmx"
            :placeholder="$t('provisional_completion_date_for_the_operation')"
            :clearable="false"
            :editable="false"
            class="big-input"
            :disabled="simulationStatus === 'TO_BE_TRANSFORMED' || isVIEWER"
            :disabled-date="notBeforeProvisionalBeginDate"
            @change="$emit('setPeriod', ficheValidator)"
          >
            <template slot="icon-calendar">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 3H4C2.34315 3 1 4.34315 1 6V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V6C23 4.34315 21.6569 3 20 3Z"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 9H23"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 5V1"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6 5V1"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18 5V1"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 14H7"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11 14H13"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 14H19"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 18H7"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11 18H13"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 18H19"
                  stroke="#132D48"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </date-picker>
          <!-- <div class="validation-field-holder"></div> -->
        </div>
      </div>

      <div
        :class="[
          ficheValidator.activityArea.$anyDirty &&
          ficheValidator.activityArea.$invalid
            ? 'field-hasError'
            : '',
          !ficheValidator.activityArea.required ? 'field-isRequired' : ''
        ]"
        class="giga-input_field col-lg-6"
      >
        <label class="input-field_label"
          >{{ $t("what_is_the_sector_of_activity") }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-field_area">
          <select
            id="activityArea"
            :disabled="isVIEWER"
            v-model="ficheValidator.activityArea.$model"
            class="small-input"
            @change="$emit('workTypeBySector', ficheValidator)"
          >
            <option
              v-for="sector of applicationSectors"
              :key="sector.value"
              :value="sector.value"
            >
              {{ sector.name }}
            </option>
          </select>
          <div
            class="validation-field-holder"
            v-if="
              ficheValidator.activityArea.$anyDirty &&
                ficheValidator.activityArea.$invalid
            "
          >
            <small v-if="!ficheValidator.activityArea.required">
              {{ $t("required_field") }}
            </small>
          </div>
        </div>
      </div>

      <div
        :class="[
          ficheValidator.activityArea.$anyDirty &&
          ficheValidator.activityArea.$invalid
            ? 'field-hasError'
            : '',
          !ficheValidator.activityArea.required ? 'field-isRequired' : ''
        ]"
        v-if="
          ficheValidator.activityArea.$model &&
            ficheValidator.provisionalBeginDate.$model
        "
        class="giga-input_field col-lg-6"
      >
        <label class="input-field_label"
          >{{ $t("type_work") }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-field_area">
          <select
            id="workType"
            :disabled="isVIEWER"
            v-model="ficheValidator.workType.$model"
            class="small-input"
            @change="$emit('fetchFiches', ficheValidator)"
          >
            <option
              v-for="workType of ficheValidator.workTypes.$model"
              :key="workType.value"
              :value="workType.value"
            >
              {{ workType.name }}
            </option>
          </select>
          <div
            class="validation-field-holder"
            v-if="
              ficheValidator.activityArea.$anyDirty &&
                ficheValidator.activityArea.$invalid
            "
          >
            <small v-if="!ficheValidator.activityArea.required">
              {{ $t("required_field") }}
            </small>
          </div>
        </div>
      </div>

      <div
        :class="[
          ficheValidator.ficheNumber.$anyDirty &&
          ficheValidator.ficheNumber.$invalid
            ? 'field-hasError'
            : '',
          !ficheValidator.ficheNumber.required ? 'field-isRequired' : ''
        ]"
        v-if="ficheValidator.workType.$model"
        class="giga-input_field col-lg-12"
      >
        <label class="input-field_label"
          >{{ $t("plug_cee") }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-field_area">
          <multiselect
            id="ficheNumber"
            :key="'fiche-select-' + ficheValidator.tabFicheIndex"
            :disabled="isVIEWER"
            :searchable="true"
            v-model="selectedFiche"
            :options="ficheValidator.fiches.$model"
            open-direction="bottom"
            :multiple="false"
            track-by="id"
            :custom-label="customFicheLabel"
            :filter-results="customFilter"
            :close-on-select="true"
            :allow-empty="false"
            @input="updateFiche"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.name }} ({{ option.number }})
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.name }} ({{ option.number }})
            </template>
            <template slot="caret">
              <div
                class="multiselect__select d-flex align-items-center justify-content-center"
              >
                <div>
                  <b-icon icon="chevron-down"></b-icon>
                </div>
              </div>
            </template>
          </multiselect>
          <div>
            <div
              class="validation-field-holder"
              v-if="
                ficheValidator.ficheNumber.$anyDirty &&
                  ficheValidator.ficheNumber.$invalid
              "
            >
              <small v-if="!ficheValidator.ficheNumber.required">
                {{ $t("required_field") }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralInformations",
  props: [
    "ficheValidator",
    "applicationSectors",
    "simulationStatus",
    "isVIEWER",
    "contractingDate",
    "deliveryDate",
  ],
  data() {
    return {};
  },
  computed: {
    selectedFiche() {
      return this.ficheValidator.fiches.$model.find(
        fiche => fiche.id === this.ficheValidator.ficheNumber.$model
      );
    }
  },
  watch: {
    "ficheValidator.ficheNumber.$model"(newVal) {
      if (newVal === null) {
        this.selectedFiche = null;
      }
    }
  },
  methods: {
    customFicheLabel(option) {
      return `${option.name} (${option.number})`;
    },
    customFilter(options, search) {
      if (!search) return options;
      search = search.toLowerCase();

      return options.filter(option => {
        return (
          option.name.toLowerCase().includes(search) ||
          option.number.toLowerCase().includes(search)
        );
      });
    },
    updateFiche(selectedFiche) {
      this.ficheValidator.ficheNumber.$model = selectedFiche
        ? selectedFiche.id
        : null;
      this.$emit("getFormConditions", this.ficheValidator);
    },
    notAfterProvisionalCompletionDate(date) {
      if (this.ficheValidator.provisionalCompletionDate.$model) {
        return (
          date >
          new Date(
            new Date(
              this.ficheValidator.provisionalCompletionDate.$model
            ).setHours(0, 0, 0, 0)
          )
        );
      }
    },
    notBeforeProvisionalBeginDate(date) {
      if (this.ficheValidator.provisionalBeginDate.$model) {
        return (
          date <
          new Date(
            new Date(this.ficheValidator.provisionalBeginDate.$model).setHours(
              0,
              0,
              0,
              0
            )
          )
        );
      }
    }
  },mounted() {
    const clientType = this.$store.getters["account/getCurrentUser"].clientType;

    const formatDate = date =>
        typeof date === "string" ? date.slice(0, 10) : null;

    if (
        clientType === "B2B2B" &&
        this.contractingDate &&
        this.deliveryDate &&
        !this.ficheValidator.provisionalBeginDate.$model &&
        !this.ficheValidator.provisionalCompletionDate.$model
    ) {
      this.ficheValidator.provisionalBeginDate.$model = formatDate(this.contractingDate);
      this.ficheValidator.provisionalCompletionDate.$model = formatDate(this.deliveryDate);
    }

    if (
        ["B2B", "ARTISAN", "BAILLEUR_SOCIAL"].includes(clientType) &&
        this.deliveryDate &&
        !this.ficheValidator.provisionalCompletionDate.$model
    ) {
      this.ficheValidator.provisionalCompletionDate.$model = formatDate(this.deliveryDate);
    }
  }
}
</script>

<style lang="scss">
#ficheNumber {
  display: flex;
  flex-direction: column;
  order: -1;
  width: 100px;
  height: 55%;
  padding: 8px;
  border: 0px;
  border-radius: 5px;
  margin-bottom: 5px;
}
</style>
